import template from './swag-cms-extensions-form-fields.html.twig';
import './swag-cms-extensions-form-fields.scss';

const { Criteria } = Shopware.Data;

export default {
    template,

    inject: [
        'repositoryFactory',
    ],

    mixins: [
        'swag-cms-extensions-form-group-field-error',
    ],

    computed: {
        store() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm');
        },

        form() {
            return this.store.form;
        },

        groups() {
            return this.form.groups;
        },

        activeItem() {
            return this.store.activeItem;
        },

        groupRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_form_group');
        },

        fieldRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_form_group_field');
        },

        formHasGroups() {
            return this.groups.length > 0;
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            if (this.groups.length >= 1) {
                this.setFirstGroupAsActiveItem();
                return;
            }

            const criteria = new Criteria();
            criteria.addFilter(
                Criteria.equals('formId', this.form.id),
            );
            criteria.addAssociation('fields');
            criteria.addSorting(Criteria.sort('position'));
            criteria.getAssociation('fields').addSorting(Criteria.sort('position'));

            this.groupRepository.search(criteria, Shopware.Context.api).then((groups) => {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFormProperty('groups', groups);

                if (this.groups.length >= 1) {
                    this.setFirstGroupAsActiveItem();
                }
            });
        },

        setFirstGroupAsActiveItem() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem = this.groups[0];
        },

        onStartEditor() {
            this.onGroupAdd();
        },

        onGroupAdd() {
            const store = Shopware.Store.get('swCmsDetailCurrentCustomForm');

            store.addGroup(
                this.groupRepository,
                this.$tc(
                    'swag-cms-extensions.sw-cms.components.form-editor.group.groupNamePrefix',
                ),
                Shopware.Context.api,
            );

            store.addField(
                store.form.groups.last().id,
                this.fieldRepository,
                Shopware.Context.api,
                this.$tc(
                    'swag-cms-extensions.sw-cms.components.form-editor.group.field.fieldPrefix',
                ),
            );

            this.validateDuplicateTechnicalName(this.form, this.form.groups.last().fields.last());
        },
    },
}
